import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  unloadPartner,
  viewPartner,
} from '../../modules/partnerModule/partner';
import { Box } from '@mui/material';
import PartnerTemplate from '../../components/partnermng/PartnerTemplate';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import PartnerInfoContainer from './PartnerInfoContainer';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import ParFileListContainer from './files/ParFileListContainer';
import ParEmpListContainer from './employees/ParEmpListContainer';
import ParProductPriceListContainer from './productprice/ParProductPriceListContainer';
import PartnerGuideInfo from '../../components/partnermng/PartnerGuideInfo';

const PartnerContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { partner, error, loading } = useSelector(
    ({ partnerModule, loading }) => ({
      partner: partnerModule.partner.partner,
      error: partnerModule.partner.error,
      loading: loading['partner/VIEW_PARTNER'],
    }),
  );

  useEffect(() => {
    dispatch(viewPartner(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadPartner());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (partner) {
      let title = {
        name: '[' + partner.partnerTyp + '] ' + partner.partnerNm,
        no: partner.partnerUuid,
      };
      setTitleData(title);
    }
  }, [partner]);

  const handleGoBack = () => {
    navigate('/partnermng');
  };

  const handleEdit = () => {
    navigate(`/partnermng/${id}/edit`);
  };

  const handleDelete = () => {
    console.log(partner);
  };

  return (
    <PartnerTemplate partner={partner} loading={loading} error={error}>
      <TitleBox
        edit
        handleGoBack={handleGoBack}
        menuName="마스터/거래처 관리/상세보기"
        menuLink="/partnermng"
        icon="partner"
        titleData={titleData}
        handleEdit={handleEdit}
      />
      <Box sx={{ my: 1 }}>
        <PartnerGuideInfo />
      </Box>
      <DetailTemplate title="기본정보">
        <PartnerInfoContainer partner={partner} />
      </DetailTemplate>
      <DetailTemplate title="거래처 파일 관리">
        <ParFileListContainer type="view" />
      </DetailTemplate>
      <DetailTemplate title="거래처 담당자 관리">
        <ParEmpListContainer type="view" />
      </DetailTemplate>
    </PartnerTemplate>
  );
};

export default PartnerContainer;
